import { BUILDER_ROW_TYPES } from '../../../constants/campaignBuilder.js';
import { BuilderTableViewColumn } from '../../../types/builderTableView.js';
import { Dimension } from '../../../types/campaignBuilder.js';
import type { BudgetRows } from '../../../types/predictivePlanning.js';
import { BuilderRowType } from '../types.js';

export const getBudgetRows = ({
  rows,
  planStartDate,
  planEndDate,
}: {
  rows: BuilderRowType[];
  planStartDate: string;
  planEndDate: string;
}): BudgetRows =>
  rows.reduce((acc, row) => {
    if (!row.id) {
      return acc;
    }

    const subRowBudget = row.subRows?.length
      ? getBudgetRows({ rows: row.subRows, planStartDate, planEndDate })
      : {};
    const isTileRow = row.type === BUILDER_ROW_TYPES.TILE;
    const suggestedBudget = isTileRow
      ? Number(row.budget) || 0
      : Number(row.budget);
    const dateFrom = isTileRow ? (row.dateFrom ?? planStartDate) : null;
    const dateTo = isTileRow ? (row.dateTo ?? planEndDate) : null;

    return {
      ...acc,
      ...subRowBudget,
      [row.id]: {
        suggestedBudget,
        isLocked: false,
        tileId: row.campaign ?? null,
        type:
          row.type === BUILDER_ROW_TYPES.MEDIA_NETWORK
            ? BUILDER_ROW_TYPES.PLATFORM
            : row.type,
        parentId: row.parent ? String(row.parent) : null,
        dateFrom,
        dateTo,
      },
    };
  }, {});

export const compareDimensionColumns = (
  columnsA: BuilderTableViewColumn[],
  columnsB: Dimension[],
) => {
  if (columnsA.length !== columnsB.length) {
    return false;
  }

  return columnsA.every((dimension, index) => {
    return dimension.name === columnsB[index]?.value;
  });
};
